module.exports = __webpack_public_path__ + "static/media/barbados.c2a34d68.jpg";